import React from 'react';
import { Redirect, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Drawer, Icon } from 'antd';
import styles from './Menu.module.css';
import Logout from './Logout';
import * as rutes from '../routes';
import { getUsuari, getVeureMenuLateral } from '../reducers';
import { LOCAL_STORAGE_USER } from '../constantsObservacions';
import {
  MISSATGE_USUARI_NO_ACTIU,
  NOM_FITXER_AJUDA,
  MISSATGE_TORNAR_FER_LOGIN,
  MISSATGE_SESSIO_JA_INICIADA
} from '../constantsFormularis';
import {
  calFerLogin,
  senseRols,
  isObservadorAdmin,
  tokenDecoded,
  esPaginaPublica,
  navToPaginaPublica,
  getIdObservadorToken
} from '../utils/usuariRols';
import configuracio from '../configuracioEntorns';
import {
  switchVisibilitatMenuLateral,
  canviTextCercaVista,
  errorConsultaServidor,
  esborrarValors
} from '../actions';
import { fetchObtenirDadesUsuariPerIdObservador } from '../actions/consultesServidor';

class Menu extends React.Component {
  state = { visible: false, usuariNoActiu: false };

  redirigirALogin = () => {
    const { history, esborrarValors } = this.props;
    esborrarValors();
    if (history && history.push) {
      history.push({
        pathname: rutes.rutaLogin
      });
    }
  };

  obrirMenu = async () => {
    const idObservadorToken = getIdObservadorToken();
    const idObservadorCerca = this.props.usuari.idObservador || idObservadorToken;
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));

    if (!token) {
      return this.gestioError('Avís', MISSATGE_SESSIO_JA_INICIADA);
    }

    if (!idObservadorCerca) {
      this.gestioError('Avís Error:', "Cal identificador usuari. " + MISSATGE_TORNAR_FER_LOGIN);
      return;
    }

    const dadesUsuari = await fetchObtenirDadesUsuariPerIdObservador(
      idObservadorCerca
    ).catch((error) => {
      let missatgeError = error;
      if (error.titol && error.titol.startsWith("Error validació paràmetres")) {
        missatgeError = error.message;
      }
      this.gestioError('Avís Error:', missatgeError + " " + MISSATGE_TORNAR_FER_LOGIN);
    });

    if (dadesUsuari) {
      if (!dadesUsuari.actiu) {
        this.gestioError('Avís Error:', MISSATGE_USUARI_NO_ACTIU + " " + MISSATGE_TORNAR_FER_LOGIN);
      } else {
        this.props.switchVisibilitatMenuLateral();
      }
    }
  };

  gestioError = (error, tipusError) => {
    this.setState({ usuariNoActiu: true });
    this.redirigirALogin();
    this.props.errorConsultaServidor(error, tipusError);
  };

  tancarMenu = () => {
    const { switchVisibilitatMenuLateral, canviTextCercaVista } = this.props;
    switchVisibilitatMenuLateral();
    const valorTextCerca = '';
    const valorColumnaCerca = '';
    canviTextCercaVista(valorTextCerca, valorColumnaCerca);
  };

  renderMenuItem = (nom, url) => (
    <li>
      <NavLink onClick={this.tancarMenu} exact to={url}>
        {nom}
      </NavLink>
    </li>
  );

  renderSegonsPerfilUsuari = (esPinta, nom, ruta) => {
    return esPinta ? this.renderMenuItem(nom, ruta) : null;
  };

  renderAjuda = (pathFitxerS3) => (
    <li>
      <a
        href={pathFitxerS3}
        target="_blank"
        rel="noopener noreferrer"
        title="Ajuda (obre en finestra nova)"
      >
        Ajuda (pdf)
      </a>
    </li>
  );

  renderPaginaPublica = () => {
    const route = navToPaginaPublica();
    return <Redirect to={route} />;
  };

  recuperarUsuari = (usuari) => {
    if (!calFerLogin(usuari)) {
      return this.tokenTrobat(usuari);
    } else {
      const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
      if (token) {
        return this.tokenTrobat(tokenDecoded(token.token));
      } else {
        return <Redirect to={rutes.rutaLogin} />;
      }
    }
  };

  tokenTrobat = (usuari) => {
    const isAdmin = isObservadorAdmin(usuari);
    const sempreEsRenderitza = senseRols(usuari) ? false : true;
    const pathS3FitxerAjuda = configuracio.S3.url;
    const { veureMenuGeneral } = this.props;
    return (
      <div className={styles.menu}>
        <Icon
          type="menu"
          style={{ fontSize: 30 }}
          onKeyPress={this.obrirMenu}
          onClick={this.obrirMenu}
          tabIndex="0"
        />

        <Drawer
          placement="left"
          title="Fenologia"
          onClose={this.tancarMenu}
          visible={veureMenuGeneral}
          className={styles.nav}
        >
          <ul>
            {this.renderSegonsPerfilUsuari(
              sempreEsRenderitza,
              'Introduir observacions',
              rutes.rutaObservacionsIntroduccio
            )}
            {this.renderSegonsPerfilUsuari(
              sempreEsRenderitza,
              'Visualitzar observacions',
              rutes.rutaObservacionsVisualitzacio
            )}
            {this.renderSegonsPerfilUsuari(
              sempreEsRenderitza,
              'Visualitzar observadors',
              rutes.rutaObservadorsVisualitzacio
            )}

            {this.renderSegonsPerfilUsuari(
              isAdmin,
              'Observadors',
              rutes.rutaObservadors
            )}
            {this.renderSegonsPerfilUsuari(
              isAdmin,
              'Indrets',
              rutes.rutaIndrets
            )}
            {this.renderSegonsPerfilUsuari(
              isAdmin,
              'Individus',
              rutes.rutaIndividus
            )}
            {this.renderSegonsPerfilUsuari(
              sempreEsRenderitza,
              'Perfil',
              rutes.rutaPerfil
            )}

            {this.renderAjuda(pathS3FitxerAjuda + NOM_FITXER_AJUDA)}

            <li>
              <Logout />
            </li>
          </ul>
        </Drawer>
      </div>
    );
  };

  render() {
    const { usuariNoActiu } = this.state;

    if (usuariNoActiu) {
      const urlBase = configuracio.ruta;
      return <Redirect to={`${urlBase}/login`} />;
    }

    return esPaginaPublica()
      ? this.renderPaginaPublica()
      : this.recuperarUsuari(this.props.usuari);
  }
}

Menu.propTypes = {
  usuari: PropTypes.object,
  veureMenuGeneral: PropTypes.bool,
  canviTextCercaVista: PropTypes.func,
  switchVisibilitatMenuLateral: PropTypes.func,
  errorConsultaServidor: PropTypes.func,
  history: PropTypes.object,
  esborrarValors: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  errorConsultaServidor,
  switchVisibilitatMenuLateral,
  canviTextCercaVista,
  esborrarValors
};

const mapStateToProps = (state) => {
  return {
    usuari: getUsuari(state),
    veureMenuGeneral: getVeureMenuLateral(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
